let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bY3RL")).then(() => parcelRequire('bcKCM'));